import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=00d5031c&scoped=true"
import script from "./ProductGallery.vue?vue&type=script&lang=ts"
export * from "./ProductGallery.vue?vue&type=script&lang=ts"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&id=00d5031c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d5031c",
  null
  
)

export default component.exports